<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view  v-if="!$route.meta.keepAlive"></router-view>
    <!-- 版本更新提示组件 -->
    <VersionUpdateTip />
  </div>
</template>

<script>
import VersionUpdateTip from '@/components/VersionUpdateTip.vue'

export default {
  name: 'App',
  components: {
    VersionUpdateTip
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue